export abstract class Exporter {
    abstract exportModel(outputFileName: string, scene: any, onFileConverted: (convertedFile: any) => void, withKey?: string): Promise<void>;
}